import AboutUs from "../../components/aboutUs/AboutUs";

function AboutUsPage() {
    return (
        <>
            <AboutUs />
        </>
    );
}

export default AboutUsPage;
